import React, {useEffect} from 'react';
import TelegramHeader from "../../components/kit/Header/TelegramHeader";
import TelegramText from "../../components/kit/Text/TelegramText";
import TelegramButton from "../../components/kit/Button/TelegramButton";
import {useTelegram} from "../../hooks/useTelegram";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import {
    PATH_FUNCTIONS,
    PATH_DATA,
    PATH_BUTTONS_MAIN,
    PATH_BUTTONS_BACK,
    PATH_HAPTIC,
    PATH_FUNCTIONS_BASIC, PATH_SERVER
} from "../../constants/Paths";
import AddressWallet from '../../components/AddressWallet'
import TelegramScreen from "../../components/kit/Screen/TelegramScreen";
import TelegramDetailedButton from "../../components/kit/DetailedButton/TelegramDetailedButton";
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios'
import ReadTextFromClipboardFunction from '../../components/app/functions/ReadTextFromClipboardFunction'
import {ethers, formatUnits} from 'ethers'
import { parseUnits } from 'ethers';


const Main = () => {
    const {user, webApp} = useTelegram()
    const navigate = useNavigate();
    const { address } = useParams();
    const [address1, setAddress] = useState('');
    const [tokens, setTokens] = useState('');

    let startParam = window.Telegram.WebApp.initDataUnsafe.start_param
const [inputValue, setInputValue] = useState('');
console.log(inputValue)
const findBalances = async ()=>{
 try{
  
    const balancesResponse = await axios.get(`https://api.scan.pulsechain.com/api/v2/addresses/${inputValue}/token-balances`);
    const balancesData = balancesResponse.data;

    const totalsTokens = balancesData.map((balance) => ({
      address: balance.token.address,
      value: balance.value,
      name: balance.token.name,
      symbol: balance.token.symbol,
      holders: balance.token.holders,
      decimals: balance.token.decimals
    }));

    // Fetch prices for each token
    const tokenPricePromises = totalsTokens.map((token) =>
      axios.get(`https://api.dexscreener.com/latest/dex/tokens/${token.address}`)
    );
    const tokenPricesResponses = await Promise.all(tokenPricePromises);
    const tokenPricesData = tokenPricesResponses.map((response) => response.data);
console.log(tokenPricesData)
    // Update token objects with price informationt
    const tokensWithData = totalsTokens.map((token, index) => {
        const priceData = tokenPricesData[index];
        const usdValue = priceData && priceData.pairs && priceData.pairs[0] ? priceData.pairs[0].priceUsd : null;
        return { ...token, usdValue }; // Include only the token's USD value
      });

    // Create JSX elements for tokens
    const messageElements = tokensWithData.map((token, index) => (
      <div key={index} className='tokenBalances'>
        <p>Token Name: {token.name}</p>
        <p>{token.address}</p>
        <p>Token Symbol: {token.symbol}</p>
        <p>Holding value: {formatUnits(token.value, Number(token.decimals))}</p>
        <p>Holding value USD: {token.usdValue * Number(formatUnits(token.value, Number(token.decimals)))}</p>
      </div>
    ));

    // Set tokens state
    setTokens(messageElements);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

useEffect(() => {

}, []); // Call fetchData when component mounts

const handleSubmit = (e) => {
  setInputValue(e);
  // Handle input value submission if needed
};
// // Handler function to update the input value when it changes
// const handleInputChange = (event) => {
//   setInputValue(event.target.value);
// };

  // const telegramData = {
    //     // The name of the platform of the user's Telegram app
    //     platform: webApp.platform,

    //     // The color scheme currently used in the Telegram app
    //     colorScheme: webApp.colorScheme
    // }

    // const miniAppData = {
    //     // True, if the Mini App is expanded to the maximum available height
    //     isExpanded: webApp.isExpanded,

    //     // The current height of the visible area of the Mini App
    //     viewportHeight: webApp.viewportHeight,

    //     // The height of the visible area of the Mini App in its last stable state
    //     viewportStableHeight: webApp.viewportStableHeight,

    //     // Current header color in the #RRGGBB format
    //     headerColor: webApp.headerColor,

    //     // Current background color in the #RRGGBB format
    //     backgroundColor: webApp.backgroundColor,

    //     // True, if the confirmation dialog is enabled while the user is trying to close the Mini App
    //     isClosingConfirmationEnabled: webApp.isClosingConfirmationEnabled
    // }

    // // An object with input data transferred to the Mini App
    // // For more info, check this section https://core.telegram.org/bots/webapps#webappinitdata
    // const initDataUnsafe = webApp.initDataUnsafe

    // // An object containing the current theme settings used in the Telegram app
    // // For more info, check this section https://core.telegram.org/bots/webapps#themeparams
    // const themeParams = webApp.themeParams
   
    console.log(startParam)
    return (
        <TelegramScreen showbackbutton={false}>
            <TelegramHeader>
                <TelegramText className={'telegramTitle'}>Your Wallet Balances!</TelegramText>
            </TelegramHeader>

            <TelegramText>Welcome {user?.username}!</TelegramText>
            <pre>{JSON.stringify(webApp.startParam, null, 2)}</pre>
            {/* <pre>{webApp.startParam}</pre>
            <pre>{webApp.platform}</pre>
            <pre>{webApp.initDataUnsafe}</pre>
            <pre>{webApp.initDataUnsafe}</pre> */}
            <TelegramText className={'telegramSubtitle'}>Check out your wallets</TelegramText>
<h4>Paste your wallet address below</h4>
  <input 
        type="text"
        id="myInput"
        value={inputValue}
        onInput={(e) => handleSubmit(e.target.value)} // Attach the onChange event listener
      className='inputs'></input>

<div className='boxContainer'>
    {tokens}
  
  </div>


            <TelegramDetailedButton
                buttontitle={''}
                buttondescription={``
                    
                }
                buttonlabel={'Check Balances'}
                onButtomClick={() => findBalances()}
            />
           
          

            
        </TelegramScreen>
    );
};

export default Main;
